import { render, staticRenderFns } from "./CollateralShareModal.vue?vue&type=template&id=499cfbe4&scoped=true&"
import script from "./CollateralShareModal.vue?vue&type=script&lang=js&"
export * from "./CollateralShareModal.vue?vue&type=script&lang=js&"
import style0 from "./CollateralShareModal.vue?vue&type=style&index=0&id=499cfbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cfbe4",
  null
  
)

export default component.exports